export default {
  methods: {
    prepareData: function (data) {
      if (!data.id) return;
      if (data.id === "email") {
        this.payload[data.id] = data.value;
      } else {
        if (!this.payload.profile) this.payload.profile = {};
        // get data from first step
        if (/* this.scienceValue ||  */this.userData) {
          //this.payload.profile.education_degree = this.scienceValue;
          this.payload.phone = this.userData.formattedNumber;
          this.payload.phone_country_code = this.userData.countryCode;
        }
        if (this.sexValue || this.sexValue === 0) {
          this.payload.profile.sex = this.sexValue;
        }
        if (this.adminStatusId || this.adminStatusId === 0) {
          this.payload.profile.admin_status_id = this.adminStatusId;
        }
        if (this.profileTagIds) {
          this.payload.profile_tag_ids = this.profileTagIds;
        }
        if (this.educationItems) {
          let educationItems_uk = [];
          let educationItems_ru = [];
          this.educationItems.forEach(educationItem => {
            educationItems_uk.push({
              year: educationItem.year,
              desc: educationItem.desc_uk,
            });
            educationItems_ru.push({
              year: educationItem.year,
              desc: educationItem.desc_uk,
            });
          });
          this.payload.profile.education = {
            uk: educationItems_uk,
            ru: educationItems_ru,
          }
        }
        // get data from fourth step
        if (this.editorToolbar) {
          this.payload.profile.about_info = {
            uk: this.psychologistsList.translated.about_info.uk,
            ru: this.psychologistsList.translated.about_info.uk,
          };
        }
        //
        if (data.id.includes(".")) {
          let parent = data.id.split(".")[0];
          let child = data.id.split(".")[1];
          if (this.payload.profile[parent]) {
            this.payload.profile[parent][child] = data.value;
          } else {
            this.payload.profile[parent] = {
              [child]: data.value,
            };
          }
          // the platform is Ukrainian only, the API still keeps a ru copy of the texts
          if (child === "uk") {
            this.payload.profile[parent].ru = data.value;
          }
        } else {
          this.payload.profile[data.id] = data.value;
        }
      }
    },
  },
};
